import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const ServicioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [servicios, setServicios] = React.useState([])

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TALLERSERVICIO).then(({ data }) => setServicios(data))
  }, [])

  return (
    <Form.Group>
      <Form.Label text='SERVICIO' htmlFor='select-idServicio' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idServicio'>
          {({ field }) => (
            <Form.Select {...field} id='select-idServicio' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
              <option value=''>Seleccionar</option>
              {servicios.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ServicioFormGroup)
